// In src/services/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions'; // Import the functions service

const firebaseConfig = {
  apiKey: "AIzaSyA_ps9YwrOpfgMP0S8IwFTjeTrjFFpSr_o",
  authDomain: "my-church-app-2.firebaseapp.com",
  projectId: "my-church-app-2",
  storageBucket: "my-church-app-2.firebasestorage.app",
  messagingSenderId: "377723642270",
  appId: "1:377723642270:web:5f29d3a417ecb3db5ab68f",
  measurementId: "G-3204P6NQBG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app); // Initialize and export functions

export { auth, db, storage, functions }; // Add functions to the export list